import { Component, inject } from '@angular/core';
import { IonButton, IonContent, IonIcon, ModalController } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { downloadOutline } from 'ionicons/icons';

@Component({
  selector: 'app-update-reminder',
  imports: [IonContent, IonButton, IonIcon],
  templateUrl: './update-reminder.component.html',
  styleUrls: ['./update-reminder.component.css'],
})
export class UpdateReminderComponent {
  private modalCtrl = inject(ModalController);

  constructor() {
    addIcons({ downloadOutline });
  }

  update() {
    this.modalCtrl.dismiss(null, 'update');
  }

  skip() {
    this.modalCtrl.dismiss(null, 'skip');
  }
}
